import { useTranslation } from 'react-i18next';

import { Box, Button, Typography } from '@frontierag/frontier-ui-library';
import { Header } from 'components';

export default function RootErrorBoundary() {
  const { t } = useTranslation('RootErrorBoundary');
  return (
    <>
      <Header showMenu={true} enableLogoClick={true} />
      <Box
        position="absolute"
        left={0}
        right={0}
        top="50%"
        mt={'-50px'}
        textAlign="center"
        data-testid="login-redirect"
      >
        <Typography variant="subtitle2" mb={4}>
          {t('errorMessage')}
        </Typography>

        <Button variant="contained" onClick={() => window.location.reload()}>
          {t('ctaLabel')}
        </Button>
      </Box>
    </>
  );
}
